import {combineReducers} from 'redux';
import {LOOKUP_LOCATION_REQUEST, LOOKUP_LOCATION_SUCCESS, LOOKUP_LOCATION_FAILURE, CLEAR_LOOKUP_LOCATION} from '../actions';

const LOOKUP_LOCATION_INITIAL_STATE = {
    latitude: 0,
    longitude: 0,
    isFetching: false,
    error: null
};

const lookupReducers = {
    [LOOKUP_LOCATION_REQUEST]: (state, action) => {
        return {...state, ...action, isFetching: true, error: null};
    },
    [LOOKUP_LOCATION_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null}
    },
    [LOOKUP_LOCATION_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [CLEAR_LOOKUP_LOCATION]: (state, action) => {
        return {...LOOKUP_LOCATION_INITIAL_STATE};
    },
};

const locationReducer = (state = LOOKUP_LOCATION_INITIAL_STATE, action) => {
    const reducer = lookupReducers[action.type] || (state => state);
    return reducer(state, action);
};

export default combineReducers({
    location: locationReducer
});


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/lookup.js